import { render, staticRenderFns } from "./survey.vue?vue&type=template&id=fda3c9e0&scoped=true&lang=pug"
import script from "./survey.vue?vue&type=script&lang=js"
export * from "./survey.vue?vue&type=script&lang=js"
import style0 from "./survey.vue?vue&type=style&index=0&id=fda3c9e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda3c9e0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/home/docker/code/frontend/components/Header.vue').default,Steps: require('/home/docker/code/frontend/components/Steps.vue').default,Body: require('/home/docker/code/frontend/components/Body.vue').default,Footer: require('/home/docker/code/frontend/components/Footer.vue').default,ConsultationNotes: require('/home/docker/code/frontend/components/ConsultationNotes.vue').default,ConsultationChecklist: require('/home/docker/code/frontend/components/ConsultationChecklist.vue').default,ConsultationScripts: require('/home/docker/code/frontend/components/ConsultationScripts.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
